import React from "react";
import { Grid, CardHeader, Tab, Tabs, Container, Switch, FormControlLabel } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import applicationLogo from "../../../design/zeiss-logo-tagline_rgb.png"
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import exampleImage from '../../../design/exampleNewSystem.png';
import { uploadFiles } from "../controller/NewSystemAction";
import WebBuilder from "../../tools/WebBuilder";
import { handleMagneticCsvInputChange, handleAcousticCsvInputChange, handleSeismicCsvInputChange, handleZipInputChange, goToAdminPanel } from "../../tools/SystemManagement";
import { VideoManager } from "../../video/VideoManager";

const TABS = {
    MAGNETIC: 0,
    ACOUSTIC: 1,
    SEISMIC: 2,
    MORE_INFO: 3
};

class AdminPanelNewSystemContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCsvMagnetic: "",
            selectedCsvAcoustic: "",
            selectedCsvSeismic: "",
            selectedZip: "",
            errorMessage: "",
            inputKey: Date.now(),
            toggleLoadingScreenDisplay: false,
            selectedTab: 0,
            editorHtml: null,
            editorJson: null,
            usingAzureStorage: false,
            enableAcousticPlotting: true,  
            enableSeismicPlotting: true    
        };
        
        this.handleUploadFiles = this.handleUploadFiles.bind(this);
        this.editor = null; 
    }
    
    // Toggle handlers
    handleAcousticPlottingToggle = (event) => {
        this.setState({ enableAcousticPlotting: event.target.checked });
    }

    handleSeismicPlottingToggle = (event) => {
        this.setState({ enableSeismicPlotting: event.target.checked });
    }
    
    handleUploadFiles = async (csvMagnetic, csvAcoustic, csvSeismic, zip) => {
        this.setState({ toggleLoadingScreenDisplay: true });

        let moreInfoToSave = null;
        let moreInfoProjectToSave = null;
        
        if (this.editor) {
            const html = this.editor.runCommand('gjs-get-inlined-html');
            if (html && html !== "<body></body>" && html !== '<body id="i4y6"></body>') {
                moreInfoToSave = html;
                moreInfoProjectToSave = this.editor.getProjectData();
            }
        }
        
        let response = await uploadFiles(
            csvMagnetic, 
            csvAcoustic, 
            csvSeismic, 
            zip, 
            moreInfoToSave, 
            moreInfoProjectToSave ? JSON.stringify(moreInfoProjectToSave) : null,
            {
                acoustic: this.state.enableAcousticPlotting,
                seismic: this.state.enableSeismicPlotting
            }
        );
        
        this.setState({ toggleLoadingScreenDisplay: false });

        const isString = typeof response.data === "string" || response.data instanceof String;

        if (!isString) {
            if ('redirect' in response.data) {
                this.props.history.push('/login')
            }

            if (response.data && (response.status === 200 || response.status === 201)) {
                goToAdminPanel(this);
                return;
            }

            // Handle validation errors
            let problemsFound = "";
            for (const [key, value] of Object.entries(response.data)) {
                problemsFound += (key + ":\n")
                let index;
                for (index = 0; index < Object.values(value).length; index++) {
                    problemsFound += ("- " + Object.values(value)[index] + '\n');
                }
            }
            this.setState({
                errorMessage: problemsFound,
                selectedCsvAcoustic: "",
                selectedCsvMagnetic: "",
                selectedCsvSeismic: "",
                selectedZip: "",
                inputKey: Date.now()
            })
        }
        else {
            this.setState({
                errorMessage: response['data'],
                inputKey: Date.now(),
                selectedCsvAcoustic: "",
                selectedCsvMagnetic: "",
                selectedCsvSeismic: "",
                selectedZip: ""
            });
        }
    };
    
    componentDidMount() {
        const azureStorage = localStorage.getItem('usingAzureStorage');
        this.setState({
            usingAzureStorage: azureStorage,
            editorHtml: null,
            editorJson: null
        });
    }

    componentWillUnmount() {
        if (this.editor) {
            this.editor = null;
        }
    }

    handleTabChange = (event, value) => {
        this.setState({ selectedTab: value });
    }

    render() {
        return <>
            <Container>
                {this.state.toggleLoadingScreenDisplay ? 
                <div>
                    <div
                    style={{
                        top: "50%",
                        left: "50%",
                        marginTop: "-50px",
                        marginLeft: "-100px",
                        position: "absolute",
                        width: "200px",
                        height: "200px"
                    }}
                >

                    <img alt="App logo" src={applicationLogo} style={{
                        width: "80%",
                        height: "80%",
                        position: "absolute",
                        left: "10%",
                        top: "5%"
                    }} />

                    <CircularProgress style={{
                        position: "absolute",
                        width: "100%",
                        height: "100%"
                    }} />
                    </div>
                    <div style={{
                        top: "75%",
                        left: "50%",
                        marginLeft: "-100px",
                        position: "absolute",
                        width: "200px",
                        height: "200px"
                    }}>
                    {this.state.usingAzureStorage &&
                    <Typography style={{textAlign:"center"}}>
                        Uploading data to cloud. This might take a few minutes...
                    </Typography>
                    }
                </div>
                </div> :
                    <Grid>
                        <Grid className="page_header">
                            <div className="page">
                                <Grid container direction="row" justifyContent="center" alignItems="center">
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <CardHeader
                                            avatar={
                                                <Avatar variant={"square"} aria-label="ripple-simulator" src={applicationLogo}
                                                    style={{
                                                        width: "80px",
                                                        height: "80px",
                                                    }
                                                    } />
                                            }
                                            titleTypographyProps={{ variant: "h4", color: 'textPrimary' }}
                                            title={"Ripple Simulator - System Creator"}
                                        />
                                    </Grid>
                                </Grid>
                            </div>
                        </Grid>
                        <Grid container direction="row">
                            <Grid item container sm={12} md={7} direction="column">
                                <Grid item container direction="column" spacing={6}>
                                    <Grid item>
                                        <Typography style={{ fontSize: 30 }}>
                                            CREATING A NEW SYSTEM
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography>
                                            <b>
                                                Images
                                            </b>
                                        </Typography>
                                        <form>
                                            <input type="file" key={this.state.inputKey} onChange={event => this.setState(handleZipInputChange(event, this))} accept=".zip" />
                                        </form>
                                    </Grid>
                                    <Grid item container spacing={2}>
                                        <Grid item>
                                            <Button variant="outlined" onClick={this.handleUploadFiles.bind(this, this.state.selectedCsvMagnetic, this.state.selectedCsvAcoustic, this.state.selectedCsvSeismic, this.state.selectedZip)}
                                                disabled={(!this.state.selectedCsvMagnetic && !this.state.selectedCsvAcoustic && !this.state.selectedCsvSeismic) || !this.state.selectedZip}>
                                                Setup System
                                            </Button>
                                        </Grid>
                                        <Grid item>
                                            <Button variant="outlined" onClick={goToAdminPanel.bind(this, this)}>
                                                Back to admin panel
                                            </Button>
                                        </Grid>
                                    </Grid>
                                    <Grid item>
                                        <Typography style={{ color: "red", marginTop: "20px", whiteSpace: 'pre-line' }}>
                                            {this.state.errorMessage}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid item style={{ marginBottom: "100px" }}>
                                    <Tabs variant="scrollable" scrollButtons="auto" indicatorColor="primary" value={this.state.selectedTab} onChange={this.handleTabChange}>
                                        <Tab label={(<Typography style={{ fontSize: "13px" }}>Magnetic distortion</Typography>)} />
                                        <Tab label={(<Typography style={{ fontSize: "13px" }}>Acoustic distortion</Typography>)} />
                                        <Tab label={(<Typography style={{ fontSize: "13px" }}>Seismic distortion</Typography>)} />
                                        <Tab label={(<Typography style={{ fontSize: "13px" }}>More information</Typography>)} />
                                    </Tabs>
                                    <div style={{ display: this.state.selectedTab === TABS.MAGNETIC ? "block" : "none" }}>
                                        <Typography style={{ marginTop: 50 }}>
                                            <b>
                                                CSV table for magnetic sensitivity
                                            </b>
                                        </Typography>
                                        <form>
                                            <input type="file" name="file" key={this.state.inputKey} onChange={event => this.setState(handleMagneticCsvInputChange(event, this))} accept=".csv" />
                                        </form>
                                    </div>
                                    <div style={{ display: this.state.selectedTab === TABS.ACOUSTIC ? "block" : "none" }}>
                                        <Typography style={{ marginTop: 50 }}>
                                            <b>
                                                CSV table for acoustic sensitivity
                                            </b>
                                        </Typography>
                                        <form>
                                            <input type="file" name="file" key={this.state.inputKey} onChange={event => this.setState(handleAcousticCsvInputChange(event, this))} accept=".csv" />
                                        </form>
                                        
                                        {/* Plotting Toggle for Acoustic */}
                                        <FormControlLabel
                                            control={
                                                <Switch 
                                                    color="primary" 
                                                    checked={this.state.enableAcousticPlotting} 
                                                    onChange={this.handleAcousticPlottingToggle} 
                                                />
                                            }
                                            label={<span style={{ fontWeight: 'bold' }}>SEM Resonance Plotting</span>}
                                            labelPlacement="end"
                                            style={{ marginTop: 20, marginBottom: 10 }}
                                        />
                                    </div>
                                    <div style={{ display: this.state.selectedTab === TABS.SEISMIC ? "block" : "none" }}>
                                        <Typography style={{ marginTop: 50 }}>
                                            <b>
                                                CSV table for seismic sensitivity
                                            </b>
                                        </Typography>
                                        <form>
                                            <input type="file" name="file" key={this.state.inputKey} onChange={event => this.setState(handleSeismicCsvInputChange(event, this))} accept=".csv" />
                                        </form>
                                        
                                        {/* Plotting Toggle for Seismic */}
                                        <FormControlLabel
                                            control={
                                                <Switch 
                                                    color="primary" 
                                                    checked={this.state.enableSeismicPlotting} 
                                                    onChange={this.handleSeismicPlottingToggle} 
                                                />
                                            }
                                            label={<span style={{ fontWeight: 'bold' }}>SEM Resonance Plotting</span>}
                                            labelPlacement="end"
                                            style={{ marginTop: 20, marginBottom: 10 }}
                                        />
                                    </div>
                                    <div style={{ display: this.state.selectedTab === TABS.MORE_INFO ? "block" : "none", width: "100%" }}>
                                        <VideoManager history={this.props.history} inputKey={this.state.inputKey} />
                                        <WebBuilder
                                            key={this.state.inputKey}
                                            onInit={(editorInstance) => {
                                                this.editor = editorInstance;
                                                
                                                // FIX: Add update listener to capture changes
                                                editorInstance.on('update', () => {
                                                    this.setState({
                                                        editorHtml: editorInstance.runCommand('gjs-get-inlined-html'),
                                                        editorJson: JSON.stringify(editorInstance.getProjectData())
                                                    });
                                                });
                                            }}
                                            initialData={null}
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                            {this.state.selectedTab !== TABS.MORE_INFO && (
                                <Grid item container sm={12} md={5}>
                                    <Grid item xs={12}>
                                        <Typography>
                                            <b>1.</b> SEM images should be collected in a specific format: <br />
                                            Image Size: 4096, 3072 <br />
                                            Ref Mag: 4x5 Polaroid <br />
                                            Image settings: Grey or RGB <br />
                                            No annotations on the images<br />
                                            As example:<br />
                                            Magnification list:<br />
                                            FEG 10K, 50K and 300K (Mag. range is then from 10K to 1000K)<br />
                                            Magnification list:<br />
                                            FEG 1K, 10K and 50K (Mag. Range is then from 1K to 200K)<br />
                                            <br />
                                            <b>2.</b> Each image should be labelled in the following order:<br />
                                            EHT: 5kv (no spaces, k lower case and V upper case)<br />
                                            Image size:  4096 (only the X size shown)<br />
                                            Mag: 10K (Polaroid 4x5 mag only, no spaces and upper case K)<br />
                                            Image pixel size: 0.053nm read off the image pixel size. Not the one from the tiff file (no commas and only in nm) <br />
                                            Example: 5kV 4092 1K 27.91nm.tif<br />
                                            The collection of the images must be Zipped to a file<br />
                                            <br />
                                            <b>3.</b> The .csv file for the SEM contains the details for: the name of the system, the EHT, the WD and the deflection expected.<br />
                                            The data from this table will allow the selection of the System, Beam energy and Working Distance that will be displayed<br />
                                            <br />
                                            <b>4.</b>No special characters allowed in the name of the system. Spaces allowed<br />
                                            Beam int: 1kV (No spaces, lower case k and UPPER CASE V, only 1 decimal with a dot)<br />
                                            WD: 8mm (No spaces, lower case m, only 1 decimal with a dot)<br />
                                            nm/mg: 0.518683 (can have 6 ore more decimals with a dot)<br />
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography> Example:</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <img style={{ width: "100%", height: "auto" }} src={exampleImage} />
                                    </Grid>
                                </Grid>)}
                        </Grid>

                    </Grid>
                }
            </Container>
        </>;
    }
}

export default withRouter(AdminPanelNewSystemContainer);